// client/src/components/contratos/GerarLinkContratoModal.js
// Gera (ou regenera) o link de assinatura remota de um contrato 'Em
// Elaboração' sem assinatura de contraparte ainda. O token em claro só
// existe no momento da geração — não há como "recuperar" um link já gerado
// antes, só emitir um novo (o anterior é invalidado). Espelha
// GerarLinkAnamneseModal.js.
import React, { useEffect, useState } from 'react';
import { Copy, Check, Loader2 } from 'lucide-react';
import FormModal from '../layout/FormModal';
import { useGerarLinkAssinaturaContrato } from '../../hooks/useContratos';

const GerarLinkContratoModal = ({ contrato, onClose }) => {
    const gerarLink = useGerarLinkAssinaturaContrato();
    const [link, setLink] = useState(null);
    const [copiado, setCopiado] = useState(false);

    useEffect(() => {
        gerarLink.mutate(contrato._id, { onSuccess: (data) => setLink(data.linkAssinatura) });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contrato._id]);

    const handleCopiar = () => {
        navigator.clipboard.writeText(link);
        setCopiado(true);
        setTimeout(() => setCopiado(false), 2000);
    };

    return (
        <FormModal title={`Link de Assinatura — Contrato Nº ${contrato.numeroContrato}`} onClose={onClose}>
            {gerarLink.isPending && (
                <div className="table-loading-state">
                    <Loader2 size={24} className="animate-spin" />
                    <span>Gerando link...</span>
                </div>
            )}

            {link && (
                <div className="form-section">
                    <p className="text-muted">
                        Envie o link abaixo para a contraparte assinar remotamente. Ela vai precisar confirmar um código de verificação antes de ver o contrato e assinar. O link expira em 7 dias.
                    </p>
                    <div className="form-group full-width">
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                            <input className="form-input" readOnly value={link} onFocus={(e) => e.target.select()} />
                            <button type="button" onClick={handleCopiar} className="action-button action-button-secondary" style={{ whiteSpace: 'nowrap' }}>
                                {copiado ? <Check size={18} className="icon" /> : <Copy size={18} className="icon" />}
                                {copiado ? 'Copiado!' : 'Copiar'}
                            </button>
                        </div>
                    </div>
                    <div className="form-actions">
                        <button type="button" onClick={onClose} className="action-button action-button-primary">Concluir</button>
                    </div>
                </div>
            )}
        </FormModal>
    );
};

export default GerarLinkContratoModal;
